import React, { useState, useEffect } from 'react'
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);
  const [username, setusername] = useState("");
  const [role, setrole] = useState("");

  // Track which submenu is open
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
      fetchData1(user);
    });
  }, []);

  const fetchData1 = async (user) => {
    try {
      if (user) {
        if (loadincount) {
          const docRef = doc(db, "authroles", user.uid)
          const docSnap = await getDoc(docRef)
          if (docSnap.exists()) {
            setrole(docSnap.data().role);
            setusername(docSnap.data().name);
            setloadincount(false)
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const navStyle = {
    color: "#cbd5e1",
    padding: "10px 5px",
    borderRadius: "8px",
    margin: "4px 0px",
    transition: "0.3s"
  };

  const activeStyle = {
    backgroundColor: "#2563eb",
    color: "#fff"
  };

  const renderMenu = (key, title, icon, items) => (
    <li className="nav-item">
      <a
        href="#"
        className="nav-link"
        style={{
          ...navStyle,
          ...(openMenu === key ? activeStyle : {})
        }}
        onClick={(e) => {
          e.preventDefault();
          toggleMenu(key);
        }}
      >
        <i className={`nav-icon fa ${icon}`} />
        <p>
          {title}
          <i className="fa fa-angle-left right"></i>
        </p>
      </a>

      <ul
        className="nav nav-treeview"
        style={{
          display: openMenu === key ? "block" : "none",
          paddingLeft: 10
        }}
      >
        {items.map((item, index) => (
          <li className="nav-item" key={index}>
            <a
              href={item.link}
              className="nav-link"
              style={navStyle}
            >
              <i className="fa fa-circle-o nav-icon"></i>
              <p>{item.name}</p>
            </a>
          </li>
        ))}
      </ul>
    </li>
  );

  const simpleLink = (title, link, icon) => (
    <li className="nav-item">
      <a href={link} className="nav-link" style={navStyle}>
        <i className={`nav-icon fa ${icon}`} />
        <p>{title}</p>
      </a>
    </li>
  );

  return (
    <aside
      className="main-sidebar elevation-4"
      style={{
        background: "linear-gradient(180deg, #0f172a, #1e293b)",
        minHeight: "100vh",
        color: "#fff"
      }}
    >
      {/* Brand Logo */}
      <a
        href="/home"
        className="brand-link"
        style={{
          backgroundColor: "#0b1220",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
          textAlign: "center"
        }}
      >
        <img
          src={window.location.origin + "/user.jpg"}
          alt="User"
          className="brand-image img-circle elevation-3"
          style={{ width: 35, height: 45 }}
        />
        <span
          className="brand-text font-weight-light"
          style={{ color: "#fff", marginLeft: -50 }}
        >
          {username}
        </span>
      </a>

      <div className="sidebar">
        <nav className="mt-3">
          <ul className="nav nav-pills nav-sidebar flex-column">

            {/* HOME */}
            <li className="nav-item">
              <a
                href="/home"
                className="nav-link"
                style={navStyle}
              >
                <i className="nav-icon fa fa-home" />
                <p>Home</p>
              </a>
            </li>

            {/* AVAK REGISTER */}
            {renderMenu("avak", "Avak Register", "fa-book", [
              { name: "Add Avak Data", link: "/avak-register" },
              { name: "View Avak Data", link: "/view-avak-data" }
            ])}

            {/* JAVAK REGISTER */}
            {renderMenu("javak", "Javak Register", "fa-book", [
              { name: "Javak Register", link: "/javak-data" },
              { name: "View Javak Data", link: "/view-javak-data" }
            ])}

            {/* BILL PAYMENTS */}
            {/* {renderMenu("bill", "Bill Payments", "fa-money", [
              { name: "Purchase Orders", link: "/purchase-orders" },
              { name: "Requisitions", link: "/requisitions" }
            ])} */}



            {/* SIMPLE LINKS */}
            {simpleLink("Store Ledger", "/store-ledger", "fa-television")}
            {simpleLink("Department", "/departments", "fa-indent")}
            {simpleLink("Products", "/products", "fa-list-ul")}

            {/* REPORTS */}
            {/* {renderMenu("report", "Reports", "fa-file", [
              { name: "Product Wise Ledger", link: "/productwise-ledger" },
              { name: "Avak Javak Report", link: "/avak-javak-report" }
            ])} */}

          </ul>
        </nav>
      </div>
    </aside>
  )
}

export default Menu
